import { climateApi, walterBIApi } from '../clients/AxiosClients'

export const getDropdown = () => {
	return walterBIApi.get('v1/ExportCsv/GetDropdown')
}

export const getDropdownFazendaEstratoFlorestal = () => {
	return walterBIApi.get('v2/ExportaInventarioCsv/busca-dropdown')
}

export const BuscaFiltros = (body) => {
	return walterBIApi.post('v2/ExportaInventarioCsv/busca-por-filtros', body)
}

export const getDropdownInventarioQualidade = () => {
	return walterBIApi.get('v2/InventarioDeQualidadeExport/busca-dados-para-dropdown')
}

export const getInventarioQualidadeXLSX = (body) => {
	var idioma = localStorage.getItem('idioma')
	idioma = 'ptbr' == idioma ? 'pt-br' : idioma
	body.Idioma = idioma

	return walterBIApi
		.post('v2/InventarioDeQualidadeExport/exportar-inventario-qualidade-xlsx', body)
		.catch((error) => {
			console.error('Error exporting inventory:', error.response.data)
			throw error
		})
}

export const getDropdownSortimento = () => {
	return walterBIApi.get('v1/ExportCsv/GetDropdownSortimento')
}

export const getDropdownPilha = () => {
	return walterBIApi.get('v1/ExportCsv/GetDropdownPilha')
}

export const getDropdownSingleTrees = () => {
	return walterBIApi.get('v1/ExportCsv/GetDropdownSingleTrees')
}

export const getArvoreCsv = (body) => {
	var idioma = localStorage.getItem('idioma')
	idioma = 'ptbr' == idioma ? 'pt-br' : idioma
	body.Idioma = idioma

	return walterBIApi.post('v1/ExportCsv/GetArvoreCsv', body)
}

export const getParcelaCsv = (body) => {
	var idioma = localStorage.getItem('idioma')
	idioma = 'ptbr' == idioma ? 'pt-br' : idioma
	body.Idioma = idioma

	return walterBIApi.post('v2/ExportaInventarioCsv/exporta-nivel-parcela-csv', body)
}

export const getTalhaoCsv = (body) => {
	var idioma = localStorage.getItem('idioma')
	idioma = 'ptbr' == idioma ? 'pt-br' : idioma
	body.Idioma = idioma

	return walterBIApi.post('v1/ExportCsv/GetTalhaoCsv', body)
}

export const getEstratoCsv = (body) => {
	var idioma = localStorage.getItem('idioma')
	idioma = 'ptbr' == idioma ? 'pt-br' : idioma
	body.Idioma = idioma

	return walterBIApi.post('v1/ExportCsv/GetEstratoCsv', body)
}

export const getInventarioPilhaEstratoCsv = (body) => {
	var idioma = localStorage.getItem('idioma')
	idioma = 'ptbr' == idioma ? 'pt-br' : idioma
	body.Idioma = idioma

	return walterBIApi.post('v1/ExportCsv/GetInventarioPilhaEstratoCsv', body)
}

export const getInventarioPilhaPlantioCsv = (body) => {
	var idioma = localStorage.getItem('idioma')
	idioma = 'ptbr' == idioma ? 'pt-br' : idioma
	body.Idioma = idioma

	return walterBIApi.post('v1/ExportCsv/GetInventarioPilhaPlantioCsv', body)
}

export const getInventarioPilhaPilhaCsv = (body) => {
	var idioma = localStorage.getItem('idioma')
	idioma = 'ptbr' == idioma ? 'pt-br' : idioma
	body.Idioma = idioma
	return walterBIApi.post('v1/ExportCsv/GetInventarioPilhaCsv', body)
}

export const getInventarioPilhaToraCsv = (body) => {
	var idioma = localStorage.getItem('idioma')
	idioma = 'ptbr' == idioma ? 'pt-br' : idioma
	body.Idioma = idioma
	return walterBIApi.post('v1/ExportCsv/GetInventarioPilhaToraCsv', body)
}

export const getAmostraCsv = (body) => {
	var idioma = localStorage.getItem('idioma')
	idioma = 'ptbr' == idioma ? 'pt-br' : idioma
	body.Idioma = idioma

	return walterBIApi.post('v1/ExportCsv/getAmostraCsv', body)
}

export const getRawDataPilha = (idMedicao) => {
	return walterBIApi.post(`v1/ExportCsv/GetRawDataPilha?idMedicao=${idMedicao}`)
}

export const getDadosClimaticosCsv = ({ farmId, startTimestamp, endTimestamp }) => {
	var idioma = localStorage.getItem('idioma')
	idioma = 'ptbr' == idioma ? 'pt-br' : idioma

	const params = new URLSearchParams()
	params.append('FarmId', farmId)
	params.append('StartTimestamp', Math.floor(startTimestamp / 1000))
	params.append('EndTimestamp', Math.floor(endTimestamp / 1000))
	params.append('Idioma', idioma)

	return climateApi.get('/Climate/csv', { params: params, responseType: 'blob' })
}
